import React, {Component} from 'react';
import './CustomerOrderTableHeader.css';

import {FormattedMessage} from "react-intl";

class CustomerOrderTableHeader extends Component{
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <tr>
                <th>
                    <FormattedMessage id="app.admin.all.order.table.id"
                                      defaultMessage="Order Id"
                                      description=""/>
                </th>
                <th>
                    <FormattedMessage id="app.admin.all.order.table.date"
                                      defaultMessage="Order Date"
                                      description=""/>
                </th>
                <th>
                    <FormattedMessage id="app.admin.all.order.table.shipping.address"
                                      defaultMessage="Shipping Address"
                                      description=""/>
                </th>
                <th>
                    <FormattedMessage id="app.admin.all.order.table.billing.address"
                                      defaultMessage="Billing Address"
                                      description=""/>
                </th>
                <th>
                    状態
                </th>
                <th>
                    <FormattedMessage id="app.admin.all.order.table.action"
                                      defaultMessage="Actions"
                                      description=""/>
                </th>
            </tr>
        )}
}
export default CustomerOrderTableHeader;



// WEBPACK FOOTER //
// ./src/components/Admin/Customer/CustomerOrderTableHeader/CustomerOrderTableHeader.js